/* Hempstore Quick-Buy - zentraler Variant-Picker fuer Produktkarten.
   Nutzt ausschliesslich die bestehende Theme-Cart-Architektur (routes, fetchConfig,
   pubsub, cart-drawer/cart-notification renderContents). Keine zweite Cart-Implementierung. */
if (!customElements.get('hs-quick-buy')) {
  customElements.define(
    'hs-quick-buy',
    class HsQuickBuy extends HTMLElement {
      constructor() {
        super();
        this.chips = Array.from(this.querySelectorAll('.hs-qb__chip'));
        this.addBtn = this.querySelector('.hs-qb__add');
        this.priceMain = this.querySelector('.hs-qb__price-main');
        this.priceUnit = this.querySelector('.hs-qb__price-unit');
        this.priceCompare = this.querySelector('.hs-qb__price-compare');
        this.errorEl = this.querySelector('.hs-qb__error');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.selected = this.chips.find(function (c) { return c.getAttribute('aria-checked') === 'true'; }) || null;

        var self = this;
        this.chips.forEach(function (chip) {
          chip.addEventListener('click', function (e) {
            // Zweite Schutzschicht: die Produktkarte ist komplett verlinkt.
            // Der eigentliche Fix ist der Stacking-Kontext in hs-quick-buy.css.
            e.preventDefault();
            e.stopPropagation();
            self.select(chip);
          });
          chip.addEventListener('keydown', function (e) { self.onKeydown(e, chip); });
        });
        if (this.addBtn) {
          this.addBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.addToCart();
          });
          if (document.querySelector('cart-drawer')) this.addBtn.setAttribute('aria-haspopup', 'dialog');
        }
        this.render();
      }

      selectableChips() {
        return this.chips.filter(function (c) { return !c.hasAttribute('disabled'); });
      }

      onKeydown(e, chip) {
        var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        e.preventDefault();
        var list = this.selectableChips();
        if (!list.length) return;
        var i = list.indexOf(chip);
        if (i === -1) i = 0;
        var next;
        if (e.key === 'Home') next = list[0];
        else if (e.key === 'End') next = list[list.length - 1];
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = list[(i + 1) % list.length];
        else next = list[(i - 1 + list.length) % list.length];
        this.select(next);
      }

      select(chip) {
        if (!chip || chip.hasAttribute('disabled')) return;
        this.chips.forEach(function (c) {
          var on = c === chip;
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });
        this.selected = chip;
        this.hideError();
        this.render();
        try { chip.focus(); } catch (err) {}
      }

      render() {
        var c = this.selected;
        if (!c) return;
        if (this.priceMain) this.priceMain.innerHTML = c.dataset.priceHtml || '';
        if (this.priceUnit) {
          this.priceUnit.innerHTML = c.dataset.unitHtml || '';
          this.priceUnit.hidden = !c.dataset.unitHtml;
        }
        if (this.priceCompare) {
          this.priceCompare.innerHTML = c.dataset.compareHtml || '';
          this.priceCompare.hidden = !c.dataset.compareHtml;
        }
        var available = c.dataset.available === 'true';
        if (this.addBtn) {
          this.addBtn.disabled = !available;
          this.addBtn.textContent = available
            ? (this.addBtn.dataset.labelAdd || 'In den Warenkorb')
            : (this.addBtn.dataset.labelSoldout || 'Ausverkauft');
        }
      }

      showError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg;
        this.errorEl.classList.add('is-visible');
      }
      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.remove('is-visible');
      }

      addToCart() {
        var self = this;
        var chip = this.selected;
        if (!chip || chip.dataset.available !== 'true' || !this.addBtn) return;
        if (this.addBtn.classList.contains('loading')) return;

        var variantId = chip.dataset.variantId;
        this.hideError();
        this.addBtn.classList.add('loading');
        this.addBtn.setAttribute('aria-disabled', 'true');

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append('sections', this.cart.getSectionsToRender().map(function (s) { return s.id; }));
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        var config;
        if (typeof fetchConfig === 'function') {
          config = fetchConfig('javascript');
        } else {
          config = { method: 'POST', headers: { Accept: 'application/javascript' } };
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

        fetch(addUrl, config)
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              self.showError(response.description || response.message || 'Nicht verfuegbar.');
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'hs-quick-buy',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message
                });
              }
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'hs-quick-buy',
                productVariantId: variantId,
                cartData: response
              });
            }
            if (self.cart && typeof self.cart.renderContents === 'function') {
              self.cart.renderContents(response);
            }
          })
          .catch(function () {
            self.showError('Es ist ein Fehler aufgetreten. Bitte erneut versuchen.');
          })
          .finally(function () {
            self.addBtn.classList.remove('loading');
            self.addBtn.removeAttribute('aria-disabled');
          });
      }
    }
  );
}